import { Flex, Image } from '@iheartjane/reefer';

import poweredByGoogle from '@jane/shared/assets/powered_by_google_on_white.png';
import poweredByGoogleHdpi from '@jane/shared/assets/powered_by_google_on_white_hdpi.png';

export const GoogleFooter = () => {
  return (
    <Flex p={4} justifyContent="flex-end">
      <Image
        width="120px"
        objectFit="scale-down"
        srcSet={`${poweredByGoogle}, ${poweredByGoogleHdpi} 2x`}
        src={poweredByGoogle}
        altText="Powered by Google"
      />
    </Flex>
  );
};
